// import { Routes, Route, Navigate } from "react-router-dom";
// import Login from "../pages/auth/Login";
// import AuthLayout from "../layouts/AuthLayout";
// import SuperAdminLayout from "../layouts/SuperAdminLayout";
// import ProtectedRoute from "./ProtectedRoute";
// import SuperAdminDashboard from "../pages/super-admin/Dashboard";
// import HospitalDetails from  "../pages/super-admin/HospitalDetails"
// import ROLES from "../utils/constants";

// const AppRoutes = () => {
//   return (
//     <Routes>
//       {/* ✅ Default route */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       <Route element={<AuthLayout />}>
//         <Route path="/login" element={<Login />} />
//       </Route>

//       <Route
//         path="/super-admin"
//         element={
//           <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN]}>
//             <SuperAdminLayout />
//           </ProtectedRoute>
//         }
//       >
//         <Route path="dashboard" element={<SuperAdminDashboard />} />
//       </Route>

//       <Route
//         path="/super-admin/hospitals/:id"
//         element={<HospitalDetails />}
//       />

//       {/* Optional: catch-all */}
//       <Route path="*" element={<Navigate to="/login" replace />} />
//     </Routes>
//   );
// };

// export default AppRoutes;

import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/auth/Login";
import AuthLayout from "../layouts/AuthLayout";
import SuperAdminLayout from "../layouts/SuperAdminLayout";
import ProtectedRoute from "./ProtectedRoute";
import SuperAdminDashboard from "../pages/super-admin/Dashboard";
import HospitalDetails from "../pages/super-admin/HospitalDetails";
import { AdminSubscriptionPage } from "../pages/super-admin";
import HospitalSubscriptionPage from "../pages/hospital/HospitalSubscriptionPage";
import ROLES from "../utils/constants";
import RegisterHospital from "../pages/auth/RegisterHospital";
import TenantDashboard from "../pages/tenant/Dashboard";
// import DashboardRedirect from "./DashboardRedirect";
import DashboardRedirect from "./DashboardRedirect";


const AppRoutes = () => {
  return (
    <Routes>
      {/* Default */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Auth */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/register" element={<RegisterHospital />} />
        <Route path="/subscription" element={<HospitalSubscriptionPage />} />
      </Route>

      {/* ✅ SUPER ADMIN AREA */}
      <Route
        path="/"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN]}>
            <SuperAdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<SuperAdminDashboard />} />
        <Route path="hospitals/:id" element={<HospitalDetails />} />
        <Route path="super-admin/subscription" element={<AdminSubscriptionPage />} />
      </Route>

      {/* ✅ TENANT ADMIN AREA */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.DOCTOR, ROLES.HOSPITAL_USER]}>
            <TenantDashboard />
          </ProtectedRoute>
        }
      />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;


